module.exports = __webpack_public_path__ + "static/media/bathrooms.fceb8c1e.svg";